/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  // countryAgentBots ({ de: botId }) replaces the bots of a marketplace inbox's
  // countries; left out, they are kept.
  setAgentBot(inboxId, botId, countryAgentBots) {
    const payload = { agent_bot: botId };
    if (countryAgentBots !== undefined) {
      payload.country_agent_bots = countryAgentBots;
    }
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, payload);
  }

  restore(inboxId) {
    return axios.post(`${this.url}/${inboxId}/restore`);
  }

  rotateHmacToken(inboxId) {
    return axios.post(`${this.url}/${inboxId}/rotate_hmac_token`);
  }

  getEmailDnsCheck(inboxId) {
    return axios.get(`${this.url}/${inboxId}/email_dns_check`);
  }

  checkEmailDns(inboxId) {
    return axios.post(`${this.url}/${inboxId}/check_email_dns`);
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  getMessageTemplates(inboxId, params = {}, config = {}) {
    return axios.get(`${this.url}/${inboxId}/message_templates`, {
      ...config,
      params,
    });
  }
}

export default new Inboxes();
